import React from "react";

export default function Instruction({ instruction }) {
	return (
		<div className="instruction">
			<div className="instruction-content">
				<h2 className="instruction-title">{instruction.title}</h2>
				<p className="instruction-description">
					{instruction.description}
				</p>
			</div>
			<div className="instruction-image">
				<video src={instruction.imageSrc} autoPlay muted loop>
					Tu navegador no admite el elemento <code>video</code>.
				</video>
			</div>
		</div>
	);
}
